import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { SiteListProvider } from '../../../data/DataProviders/SiteListProvider';
import { useSiteProfileData } from '../../../data/DataProviders/SiteProfileDataProvider';
import { useCurrentAppRoute } from '../../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../../hooks/data-hooks';
import { LocationProfileData } from './LocationProfileData';
import { isDataLoaded, SiteProfile } from "../../../types";
import { AppRoutes } from '../../../routes';
import { EditLocation } from './EditLocation';
import { DataIndicators } from '../../../components/DataIndicators';
import { Thunks } from '../../../actions';
import { useToasts } from '../../../data/DataProviders/ToastProvider';
import { useAuthHelper } from '../../../components/AuthContextProvider';
import { useDispatch } from 'react-redux';


export const LocationProfile: React.FC = (): JSX.Element => {
    const selectedOrganization = useSelectedOrganizationData();
    const currentAppRoute = useCurrentAppRoute()
    const siteProfileData = useSiteProfileData();
    const [locationData, setLocationData] = useState<SiteProfile | null>(null);
    const { addToast } = useToasts();
    const authHelper = useAuthHelper();
    const dispatch = useDispatch();

    const updatedSiteData = (modifiedData: SiteProfile): void => {
        if (isDataLoaded(siteProfileData)) {
            const data = { ...siteProfileData.value };
            data.name = modifiedData.name;
            data.address = modifiedData.address;
            data.city = modifiedData.city;
            data.country = modifiedData.country;
            data.state = modifiedData.state;
            data.zipCode = modifiedData.zipCode;
            data.description = modifiedData.description;
            dispatch(Thunks.Site.getExludedStateResponse(data.state, data.country, addToast, authHelper));
            setLocationData(data);
        }
    }
    useEffect(() => {
        if (isDataLoaded(siteProfileData)) {
            const data = { ...siteProfileData.value };
            dispatch(Thunks.Site.getExludedStateResponse(data.state, data.country, addToast, authHelper));
            setLocationData(siteProfileData.value);
        }
    }, [siteProfileData])
    return (
        <>
            <DataIndicators
                errorMessage="No Location Data"
                emptyMessage="No Location Data"
                data={siteProfileData}
                emptyIcon="LocationOn"
                isEmpty={locationData === null}
            />
            {'locationId' in currentAppRoute && isRecordFound(selectedOrganization) && locationData && (
                <>
                    <Route exact path={AppRoutes.LocationProfile} >
                        <SiteListProvider locationId={currentAppRoute.locationId}>
                            <LocationProfileData data={locationData} />
                        </SiteListProvider>
                    </Route>
                    <Route exact path={AppRoutes.EditLocation} >
                        <EditLocation updatedLocationData={updatedSiteData} data={locationData} />
                    </Route>
                </>
            )}
        </>)
}